import { ArrowRight, CircleHelp } from "lucide-react";
import { Button } from "components/ui/button";
import { cn } from "lib/utils";
import "./empty-state.css";

function EmptyState({
  primaryActionIcon: PrimaryActionIcon = ArrowRight,
  primaryActionLabel,
  primaryActionVariant = "primary",
  className,
  compact = false,
  description,
  icon: Icon = CircleHelp,
  onPrimaryAction,
  onSecondaryAction,
  secondaryActionIcon: SecondaryActionIcon = ArrowRight,
  secondaryActionLabel,
  secondaryActionVariant = "secondary",
  title,
}) {
  return (
    <div
      aria-live="polite"
      className={cn("ui-empty-state", compact && "ui-empty-state--compact", className)}
      role="status"
    >
      <span aria-hidden="true" className="ui-empty-state-icon">
        <Icon size={compact ? 20 : 22} strokeWidth={1.7} />
      </span>
      <div className="ui-empty-state-copy">
        <h3 className="ui-empty-state-title">{title}</h3>
        <p className="ui-empty-state-description">{description}</p>
      </div>
      {(primaryActionLabel || secondaryActionLabel) && (
        <div className="ui-empty-state-actions">
          {primaryActionLabel && (
            <Button className="ui-empty-state-action ui-empty-state-primary-cta" onClick={onPrimaryAction} size="sm" type="button" variant={primaryActionVariant}>
              <PrimaryActionIcon aria-hidden="true" size={15} strokeWidth={1.8} />
              {primaryActionLabel}
            </Button>
          )}
          {secondaryActionLabel && (
            <Button className="ui-empty-state-action ui-empty-state-secondary-cta" onClick={onSecondaryAction} size="sm" type="button" variant={secondaryActionVariant}>
              <SecondaryActionIcon aria-hidden="true" size={15} strokeWidth={1.8} />
              {secondaryActionLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

export { EmptyState };
